/* jshint esversion: 6 */
import React from 'react';
import * as _ from 'underscore';

let FormUtilityMixin = {
    requestChange: function(e) {
        let nextState = this.state,
            stateKey = null,
            rootKey = null,
            updatedState = null,
            newValue = null,
			path = [],
			target = null,
			i = 0,
            field = e.currentTarget.dataset.field,
            toggleState = 0,
            matches = null;

		// field uses dot notation to specify:
        // stateKey.field.subfield.etc
		if (field.match(".")) {
			path = field.split(".");
		}

        if (!path.length) {
            return;
        }

        // get the name of the state object to update
        stateKey = path.shift();
        rootKey = stateKey.replace(/\[\d+\]/, '');
        if ((matches = stateKey.match(/\[(\d+)\]/)) !== null) {
            var stateIndex = matches[1];
            updatedState = nextState[stateKey.replace(/\[\d+\]/, '')][matches[1]];
        } else {
            updatedState = nextState[stateKey];
        }

        // the field to update will always be last
        field = path.pop();

        if (field) {
            // decend into the object if necessary
    		target = updatedState;
    		if (path.length) {
    			for (i = 0; i < path.length; ++i) {
                    if (!target[path[i]] || _.isArray(target[path[i]])) {
                        target[path[i]] = {};
                    }
    				target = target[path[i]];
    			}
    		}
        } else {
            target = nextState;
            field = stateKey;
            rootKey = stateKey;
        }

        // convert toggle values if necessary
        if (e.currentTarget.dataset.togglestate) {
			toggleState = (e.currentTarget.dataset.togglestate === 'true') ? 0 : 1;
			e.target.value = toggleState;
		}

        // convert checkbox values
        if (e.target.tagName === "INPUT" && (e.target.type === "checkbox" || e.target.type === 'radio') && e.target.checked !== undefined) {
            target[field] = (e.target.checked) ? true : false;
            // allow a secondary value to be sent with checkboxes
            if (e.target.checked && e.target.value) {
                // default value is "on" check if it's being overridden with a bitmask value
                if (!isNaN(parseInt(e.target.value))) {
                    target[field] = parseInt(e.target.value);
                }
            }
        } else {
		    target[field] = e.target.value;
        }

		// Only the top-level key this change touched. The write above has already
		// mutated this.state in place; handing setState the whole of it re-applied
		// every other key at its value from before this event, undoing any setState
		// the caller queued earlier in the same handler.
		this.setState({[rootKey]: nextState[rootKey]});

    },
    isObjectDirty: function(object, cleanObject) {
        if (_.isEqual(object, cleanObject)) {
            return false;
        }
        return true;
    }
};

export default FormUtilityMixin;
